module.exports = __webpack_public_path__ + "static/media/1POLICY48.0f5e63eb.jpg";